import { Injectable } from '@angular/core';
import { ChatFormTenantMode, ChatFormTenantResolver } from '@nimbus-global/features/chat-form/models/chat-form-tenant-resolver';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { CompanionChatResolver as BaseCompanionChatResolver } from '@nimbus-library/features/companion-chat/services/companion-chat-resolver';
import { IChatFormEntityHandler } from '@nimbus-library/features/companion-chat/services/form-entity-handlers/i-chat-form-entity-handler';

@Injectable()
export class CompanionChatResolver extends BaseCompanionChatResolver {
  public readonly formResolvers: IChatFormEntityHandler[] = [];

  public constructor(private readonly authenticationService: IAuthenticationService) {
    super();
  }

  public readonly resolveTenant: ChatFormTenantResolver = () => ({
    mode: ChatFormTenantMode.Fixed,
    tenantId: this.authenticationService.getUserInfo().tenantId,
    component: null,
  });
}
